module.exports = __webpack_public_path__ + "assets/3bd0286a8c3c8123c29271e8a677da9f.png";